export const ADMIN_EMAIL = 'analytics.pmo.support@truedigital.com';
export const ADMIN_NAME = 'Analytics Customer Support';
